(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.register = function(module) {
    return module.service('Core.Services.MapLayers.Manager', ['$injector', exports.Manager]);
  };

  exports.Manager = (function() {
    function Manager(injector) {
      this.injector = injector;
      this.get = bind(this.get, this);
      this.register = bind(this.register, this);
      this.registry = {};
      this.register(['Soil', 'SoilsLayer'], 'Core.Services.MapLayers.Soil');
      this.register(['ManagementZones', 'ManagementZonesLayer', 'IrrigationZonesLayer'], 'Core.Services.MapLayers.ManagementZone');
      this.register(['YieldMapLayer'], 'Core.Services.MapLayers.YieldMap');
      this.register(['CombinedLayers'], 'Core.Services.MapLayers.CombinedLayers');
      this.register(['PrescriptionMap'], 'Core.Services.MapLayers.PrescriptionMap');
      this.register(['PopulationMap', 'Populations'], 'Core.Services.MapLayers.PopulationMap');
      this.register(['Field', 'FieldBoundary'], 'Core.Services.MapLayers.Field');
    }

    Manager.prototype.register = function(name, servicename) {
      var cleanName, i, j, len, results;
      if (!$.isArray(name)) {
        name = [name];
      }
      results = [];
      for (j = 0, len = name.length; j < len; j++) {
        i = name[j];
        cleanName = this._cleanName(i);
        results.push(this.registry[cleanName] = servicename);
      }
      return results;
    };

    Manager.prototype.get = function(name) {
      var cleanName, service;
      cleanName = this._cleanName(name);
      if (this.registry[cleanName] != null) {
        service = this.injector.get(this.registry[cleanName]);
        if (service["new"] == null) {
          throw Error("The '" + name + "' (" + this.registry[cleanName] + ") service does not provide a 'new' method");
        }
        return service["new"]();
      } else {
        throw new Error("Invalid service nickname, " + name);
      }
    };

    Manager.prototype._cleanName = function(name) {
      name = name.toLowerCase();
      name = name.replace(/[-_ ]/g, '');
      return name;
    };

    return Manager;

  })();

}).call(this);
